/* eslint eqeqeq: "off" */
import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DownOutlined,
  RightOutlined,
  LogoutOutlined,
  UserOutlined,
  SafetyOutlined,
} from "@ant-design/icons";
import Logo from "../../assets/images/logo (1).png";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { useHistory } from 'react-router-dom';

import {
  Avatar,
  Button,
  Layout,
  theme,
  Typography,
  Image,
  Space,
  Tooltip, Dropdown, Menu, Modal, Input
} from "antd";
import api from "../../helpers";
import { Link } from "react-router-dom";
import "./index.css";
import {
  menuList,
} from "./data";
import useMedia from "use-media-antd-query";
import { isEmpty } from "lodash";
import { toast, ToastContainer } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
const { Header, Content, Footer, Sider } = Layout;


const LayoutMain = (props) => {
  const history = useHistory();
  const [sessionData, setSessionData] = useState();
  const hasFetchedRef = useRef(false);
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;

    api.post("/auth/employee/session")
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setSessionData(response?.data?.data); 
        }
      })
      .catch((err) => {
        const errorMsg =
          err?.response?.data?.error ||
          err?.response?.data?.message ||
          "Your session has expired. Please login again";

        toast.error(errorMsg);

        setTimeout(() => {
          localStorage.clear();
          history.push({
            pathname: "/employee-login",
            state: { row: "", data: "login" },
          });
        }, 1000);
      });
  }, [history]);

  //Validations
  const simpleValidator = React.useRef(
    new SimpleReactValidator({
      validators: {
        passwordRule: {
          message:
            "Password must be at least 8 characters and include uppercase, lowercase, number, and special character.",
          rule: (val) =>
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
              val
            ),
          required: true,
        },

      },
    })
  );

  const [, forceUpdate] = React.useState();

  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const media = useMedia();
  const menuPath = props && props.location ? props.location.pathname : "";
  //GET USER NAME
  const storedAuthData = localStorage.getItem("authData");
  const userDetails = storedAuthData ? JSON.parse(storedAuthData) : null;


  const userNameDetails = !isEmpty(userDetails) ? userDetails : "";

  const userName = userNameDetails ? userNameDetails.employeeName : sessionData.employeeName;
  const designation = userNameDetails ? userNameDetails.designation : sessionData?.designation?.designationName;
  const profilePicture = userNameDetails ? userNameDetails.profilePicture : "";
  const defaultPassword = userNameDetails ? userNameDetails.isDefaultPassword : "";
  const { Text } = Typography;
  const userAvatar = !isEmpty(userName) ? userName[0] : ""
  //Initial states

  const [collapsed, setCollapsed] = useState(false);
  const [subMenuSelected, setSubMenuSelected] = useState("");
  const [globalMenu, setGlobalMenu] = useState("");

  useEffect(() => {
    if (media === "md" || media === "sm" || media === "xs") {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, [media]);

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );


  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    setTimeout(() => {
      // setLoading(false);
    }, 1500);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const userRole = localStorage.getItem("userType");
  const filteredMenu = useMemo(() => {
    if (userRole === "admin") return menuList;

    if (userRole === "employee") {
      return menuList
        .filter((item) => item.key !== "reports" && item.key !== "ManageEmployee" && item.key !== "masters")
        .map((item) => {
          if (item.key === "leaveAndPermissions") {
            const filteredChildren = item.children?.filter(child => child.key !== "lop");
            return { ...item, children: filteredChildren };
          }
          return item;
        });
    }

    return [];
  }, [userRole]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const showModal = () => {
    setIsModalVisible(true)
    simpleValidator.current.hideMessages();
    forceUpdate(prev => prev + 1);
  };
  const handleCancel = () => setIsModalVisible(false);
  const handleSubmit = () => {
    if (simpleValidator.current.allValid()) {
      const payload = {
        "currentPassword": currentPassword,
        "newPassword": newPassword
      }
      api
        .post("/auth/employee/changepass", payload)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {

            toast.success("Password changed successfully");

            // clear session or token
            setIsModalVisible(false);
            setTimeout(() => {
              localStorage.clear();
              history.push({
                pathname: "/employee-login",
                state: { row: "", data: "login" }
              });
            }, 1000)

          } else {
            toast.warning(response?.data?.msg || "Unexpected response");
          }
          return response.data;
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.error || err?.response?.data?.message ||
            "An error occurred while changing the password";

          setIsModalVisible(false);
          toast.error(errorMsg);
          return Promise.reject(err);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      setIsModalVisible(true);
    }

  };
  useEffect(() => {
    if (defaultPassword === true) {
      setConfirmLogout(true);
    }
  }, [defaultPassword]);
  const [confirmLogout, setConfirmLogout] = useState(false);
  const showConfirm = () => setConfirmLogout(true);
  const handleClose = () => setConfirmLogout(false);
  const menu = (
    <Menu
      className="custom-dropdown-menu"
      items={[
        {
          key: "profile",
          icon: <UserOutlined className="text-[16px]" />,
          //  label: <Link to="/profile">Profile</Link>,
          label: "Profile"
        },
        {
          key: "changePassword",
          icon: <SafetyOutlined className="text-[16px]" />,
          label: <span onClick={showModal}>Change Password</span>,
        },
        {
          type: "divider",
        },
        {
          key: "logout",
          icon: <LogoutOutlined className="text-[16px]" />,
          label: (
            <span
              onClick={showConfirm}

            //   () => {
            //   localStorage.clear();
            //   window.location.href = "/employee-login";
            // }}
            >
              Logout
            </span>
          ),
        },
      ]}
    />
  );


  return (
    <React.Fragment>

      <Layout
        style={{
          padding: "6px",
        }}
      >
        <Sider
          collapsible
          width={240}
          trigger={null}
          theme={"dark"}
          // onScroll={true}
          collapsedWidth={75}
          collapsed={collapsed}
          style={{
            borderRadius: "10px",
            marginRight: "4px",
            overflow: "hidden",
            height: "100%",
            position: "fixed",
            boxShadow: "#dbdbdb 0px 3px 6px 3px",
            opacity: 20,
            transition: collapsed
              ? "all 800ms ease-in-out"
              : "all 800ms ease-in-out",
            // scrollBehavior: "unset",
            border: "2px solid #001529",
          }}
        >
          <>
            <div
              style={{
                padding: "5px",
                height:
                  windowDimensions.height > 700 && windowDimensions.height < 800
                    ? "8vh"
                    : windowDimensions.height > 800 &&
                      windowDimensions.height < 900
                      ? "8vh"
                      : windowDimensions.height > 900 &&
                        windowDimensions.height < 1000
                        ? "8vh"
                        : windowDimensions.height >= 1000 &&
                          windowDimensions.height < 1100
                          ? "8vh"
                          : windowDimensions.height >= 1100
                            ? "8vh"
                            : "8vh",
                display: "flex",
                flexBasis: "row",
                justifyContent: "center",
              }}
              className="pb-3"
            >
              <Image
                src={Logo}
                width={"60%"}
                preview={false}
                className="pr-3 pt-2"
                height={40}
              />

            </div>

            <div
              className={
                windowDimensions.height > 700 && windowDimensions.height < 800
                  ? "mt-3 scroll-layout h-[75vh]"
                  : windowDimensions.height > 800 &&
                    windowDimensions.height < 900
                    ? "mt-3 scroll-layout h-[75vh]"
                    : windowDimensions.height > 900 &&
                      windowDimensions.height < 1000
                      ? "scroll-layout h-[75vh]"
                      : windowDimensions.height >= 1000 &&
                        windowDimensions.height < 1100
                        ? "mt-3 scroll-layout h-[75vh]"
                        : windowDimensions.height > 1100
                          ? "mt-3 scroll-layout h-[75vh]"
                          : "mt-3 scroll-layout h-[75vh]"
              }
              style={{
                borderTop: "1px solid #242424b8",
              }}
            >
              {filteredMenu.length > 0 &&
                filteredMenu.map((data, index) => {
                  const subMenuPath =
                    data &&
                      data.children &&
                      data.children.length > 0 &&
                      menuPath
                      ? data.children.find(
                        (subMenu) => subMenu.pathname == menuPath
                      )
                      : "";
                  const subMenuPathName = subMenuPath && subMenuPath.pathname;


                  return (
                    <div key={index} className="mt-2 mb-2 pl-2.5 pr-2.5">
                      <Link
                        onClick={() => {
                          if (data.label) {
                            setGlobalMenu(data.label);
                          } else {
                            setGlobalMenu(data.label);
                          }
                          if (
                            subMenuSelected === data.label &&
                            data.children &&
                            data.children.length > 0
                          ) {
                            setSubMenuSelected("");
                          } else {
                            setSubMenuSelected(data.label);
                          }
                        }}
                        to={{
                          pathname: data.pathname,
                        }}
                        className={
                          // globalMenu === data.label ||
                          menuPath == data.pathname
                            ? "flex justify-between text-[#ffffff] sidebar-header-list font-medium bg-[#4399e9bf] p-2 mt-2 rounded-2xl"
                            : "flex justify-between text-[lightgray] sidebar-header-list font-medium hover:bg-[#7b6f6fb0] p-2 mt-2 rounded-2xl"
                        }
                      >

                        {data.label === "General" ||
                          data.label === "Accounting Solutions" ? (
                          <div className="mb-[-6px]">
                            <h1
                              className={
                                collapsed
                                  ? "ml-[-16px] uppercase text-[10px] text-[#ffffff]"
                                  : "ml-[-3px] uppercase text-[10px] text-[#ffffff]"
                              }
                            >
                              {data.label}
                            </h1>
                          </div>
                        ) : (
                          <div className="flex">
                            <p className="mr-2">{data.icon}</p>
                            {collapsed ? (
                              ""
                            ) : (
                              <h1 className="">{data.label}</h1>
                            )}
                          </div>
                        )}
                        {(subMenuPathName !== undefined &&
                          menuPath === subMenuPathName &&
                          data.children &&
                          data.children.length > 0) ||
                          (subMenuSelected === data.label &&
                            data.children &&
                            data.children.length > 0) ? (
                          <DownOutlined
                            className="mt-1"
                            onClick={() => {
                              setSubMenuSelected("");
                            }}
                          />
                        ) : data.children && data.children.length > 0 ? (
                          <RightOutlined
                            className="mt-1"
                            onClick={() => {
                              setSubMenuSelected(data.label);
                            }}
                          />
                        ) : (
                          ""
                        )}{" "}
                      </Link>
                      <div className="ml-2 mt-2 bg-[#181717] rounded-lg">
                        {(subMenuPathName !== undefined &&
                          menuPath === subMenuPathName) ||
                          (subMenuSelected == data.label &&
                            data.children &&
                            data.children.length > 0)
                          ? data.children.map((subMenu, index) => {
                            return (
                              <div
                                onClick={() => {
                                  setGlobalMenu(subMenu.label);
                                }}
                                key={index}
                              >
                                <Link
                                  to={{
                                    pathname: subMenu.pathname,
                                  }}
                                  className={
                                    globalMenu === subMenu.label ||
                                      menuPath === subMenu.pathname
                                      ? "flex text-[10px] text-[#ffffff] sidebar-header-list font-medium bg-[#4399e9bf] p-1 pl-2 pb-2 pt-2 mb-2 rounded-2xl"
                                      : "flex text-[10px] text-[lightgray] sidebar-header-list font-medium hover:bg-[#7b6f6fb0] p-1 pl-2 pb-2 pt-2 mb-2 rounded-2xl"
                                  }
                                >
                                  <p className="text-[12px] mr-2 mt-1 hover:text-[#ffffff]">
                                    {subMenu.icon}
                                  </p>
                                  {collapsed ? (
                                    ""
                                  ) : (
                                    <h1 className="text-[12px] hover:text-[#ffffff">
                                      {subMenu.label}
                                    </h1>
                                  )}
                                </Link>
                              </div>
                            );
                          })
                          : ""}
                      </div>
                    </div>
                  );
                })}
            </div>
            <div
              style={{
                marginTop: "15px",
                background: "#fff",
                padding: "8px 12px",
                borderRadius: 8,
                marginLeft: 24,
                marginRight: 24,
                display: "flex",
                alignItems: "center",
                justifyContent: collapsed ? "center" : "space-between",
              }}
            >

              {!collapsed ? (
                <>
                  <Space>
                    <Avatar
                      src={profilePicture || null}
                      style={{
                        ...(profilePicture
                          ? { objectFit: "cover" } // only image-specific styles
                          : {
                            backgroundColor: "#8400ff",
                            textTransform: "capitalize",
                          }),
                      }}
                      size={32}
                    >
                      {!profilePicture && userAvatar}
                    </Avatar>

                    <Text style={{ fontSize: 14, fontWeight: 500 }}>
                      {userName}
                    </Text>
                  </Space>
                  <Tooltip title="Logout">

                    <LogoutOutlined
                      style={{ fontSize: 16, cursor: "pointer", color: "#000" }}
                      onClick={showConfirm}
                    />

                  </Tooltip>
                </>
              ) : (
                <Tooltip title="Logout">

                  <LogoutOutlined
                    style={{ fontSize: 20, cursor: "pointer", color: "#000" }}
                    onClick={showConfirm}
                  />

                </Tooltip>
              )}
            </div>

            {/* Collapse Toggle Button */}
            <div
              onClick={() => setCollapsed(!collapsed)}
              style={{
                marginTop: 20,
                fontSize: 18,
                cursor: "pointer",
                textAlign: "center",
                color: "#000",
              }}
            >
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </div>


            {/* <div className={"sidebar-settings-main h-[vh]"}>
              <div className={"sidebar-settings mt-5"}></div>
              {!collapsed ? (
                <div
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "13px",
                  }}
                  className="flex space-evenly mt-3 ml-4"
                >
                  <Typography className="text-start text-[#a3a3a3] text-[10px]">
                    <SafetyCertificateOutlined className="mx-1" /> 100% secure
                  </Typography>
                  <Typography className="mx-4 text-start text-[#a3a3a3] text-[10px]">
                    <BankOutlined className="mx-1" />
                    ISO 27001 Certified
                  </Typography>
                </div>
              ) : (
                ""
              )}
            </div> */}
          </>
        </Sider>
        <Layout
          className={collapsed ? "pl-[85px]" : "pl-[245px]"}
          style={{
            transition: collapsed
              ? "all 800ms ease-in-out"
              : "all 800ms ease-in-out",
          }}
        >
          <Header
            style={{
              padding: 0,
              background: colorBgContainer,
              textAlign: "start",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: "16px",
                width: 64,
                height: 64,
              }}
            />
            {/* <Popover
  trigger="click"
  placement="bottom"
  content={ProfileDetails}
  className="w-[190px] mt-4 mr-6 border border-gray-100 rounded-md"
>
  <div className="flex justify-between items-center w-full">
    <div className="flex items-center pl-2 pr-2 gap-2 w-full flex-wrap">
      <span
        className="text-[12px] text-black font-semibold uppercase"
        style={{
          whiteSpace: "normal",
          wordBreak: "break-word",
        }}
      >
        Welcome Lokeshwaran Jeevanantham
      </span>
      <Avatar
        style={{
          backgroundColor: "#8400ff",
          textTransform: "capitalize",
          flexShrink: 0,
        }}
        size="small"
      >
        {userAvatar}
      </Avatar>
    </div>
    <DownOutlined className="cursor-pointer pl-2 pr-2" />
  </div>
</Popover> */}
            <div className="flex items-center gap-3 ml-2 mr-8">
              {/* Avatar */}
              <Avatar
                src={profilePicture || null}
                style={{
                  ...(profilePicture
                    ? { objectFit: "cover" } // only image-specific styles
                    : {
                      backgroundColor: "#8400ff",
                      textTransform: "capitalize",
                    }),
                }}
                size="large"
              >
                {!profilePicture && userAvatar}
              </Avatar>

              {/* Welcome Texts */}
              <div className="flex flex-col leading-tight">
                <span className="text-[10px] font-medium tracking-wide text-[#38B6FF]">Welcome</span>
                <span className="text-[14px] text-black font-semibold leading-[1.2]">
                  {userName}
                </span>
                <span className="text-[9px] text-[#d1d5db] font-normal">
                  {designation}
                </span>
              </div>

              {/* Dropdown */}
              <Dropdown overlay={menu} trigger={["click"]}>
                <DownOutlined className="cursor-pointer text-gray-500 ml-2 text-sm hover:text-[#8400ff]" />
              </Dropdown>

              {/* Change Password Modal */}

              <Modal
                open={isModalVisible}
                onCancel={handleCancel}
                title={"Change Password"}
                cancelText="Cancel"
                className="poppins-txt custom-active-modal"
                width={450}
                centered
                footer={null} // Remove the default footer
              // style={{ padding: 0, marginLeft: "600px" }} // Remove padding from modal
              >
                <div className="custom-modal-content">
                  <div className="mb-4">
                    <Typography className="poppins-txt">
                      Current Password
                      <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                    </Typography>
                    <Input.Password
                      placeholder="Enter current password"
                      className="custom-select"
                      style={{ marginTop: "5px" }}
                      name="currentPassword"
                      value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)}
                      autoComplete="off"
                    />
                    <span
                      style={{
                        color: "#ef3022",
                        fontSize: "11px",
                        marginTop: "8px",
                        fontFamily: "poppins",
                        display: "block",
                      }}
                    >
                      {simpleValidator.current.message(
                        "currentPassword",
                        currentPassword,
                        "required"
                      )}
                    </span>
                  </div>
                  <div className="mb-4">
                    <Typography className="poppins-txt">
                      New Password
                      <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                    </Typography>
                    <Input.Password
                      placeholder="Enter new password"
                      className="custom-select"
                      style={{ marginTop: "5px" }}
                      name="newPassword"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      autoComplete="off"
                    />
                    <span
                      style={{
                        color: "#ef3022",
                        fontSize: "11px",
                        marginTop: "8px",
                        fontFamily: "poppins",
                        display: "block",
                      }}
                    >
                      {simpleValidator.current.message(
                        "newPassword",
                        newPassword,
                        "required|passwordRule"
                      )}
                    </span>
                  </div>
                </div>

                {/* Custom footer with cancel and confirm buttons */}
                <div
                  className="custom-modal-footer"
                  style={{
                    borderTop: "1px solid #ccc",
                    padding: "10px 16px",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    className="custom-btn"
                    onClick={handleCancel}
                    style={{
                      backgroundColor: "#f46a6a",
                      color: "#fff",
                      border: "none",
                      marginRight: "10px",
                    }}
                  >
                    Close
                  </Button>
                  <Button
                    className="custom-btn"
                    //   disabled={disabled}
                    // onClick={handleModalClose}
                    onClick={() => handleSubmit()}
                    style={{
                      backgroundColor: "#34c38f",
                      color: "#fff",
                      border: "none",
                    }}
                  >
                    Confirm
                  </Button>
                </div>
              </Modal>

            </div>
          </Header>
          <Content
            style={{
              borderRadius: "8px",
            }}
          >
            <div
              style={{
                padding: "8px 2px 8px 0px", // top, right, bottom, left (left set to 0)
                textAlign: "start",
                marginLeft: "0px",         // reduced left margin
              }}
              className="content-layout"
            >
              {props.children}
            </div>

          </Content>

          <Footer
            style={{
              textAlign: "center",
              position: "sticky",
              top: "4px",
              bottom: 0,
              display: "flex",
              height: "50px",
              background: "#f1f1f1",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              style={{
                fontFamily: "Poppins",
              }}
              className="text-[12px]"
            >
              Mequals ©{new Date().getFullYear()}
            </Typography>
            <Typography
              style={{
                fontFamily: "Poppins",
              }}
              className="text-[12px]"
            >
              Created by Mequals Technologies
            </Typography>
          </Footer>
        </Layout>
      </Layout>
      <Modal
        open={confirmLogout}
        onCancel={handleClose}
        title={"Confirmation"}
        cancelText="Cancel"
        className="poppins-txt custom-active-modal"
        centered
        width={450}
        footer={null} // Remove the default footer
      // style={{ padding: 0, marginLeft: "600px" }} // Remove padding from modal
      >
        <div className="custom-modal-content">
          <p>Are you sure you want to logout?</p>
        </div>

        {/* Custom footer with cancel and confirm buttons */}
        <div
          className="custom-modal-footer"
          style={{
            borderTop: "1px solid #ccc",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            className="custom-btn"
            onClick={handleClose}
            style={{
              backgroundColor: "#f46a6a",
              color: "#fff",
              border: "none",
              marginRight: "10px",
            }}
          >
            Close
          </Button>
          <Link
            to={{
              pathname: "/employee-login",
              state: { row: "", data: "login" },
            }}
            onClick={() => {
              localStorage.clear();
            }}
          >
            <Button
              className="custom-btn"
              style={{
                backgroundColor: "#34c38f",
                color: "#fff",
                border: "none",
              }}
            >
              Confirm
            </Button>
          </Link>
        </div>
      </Modal>
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
      {/* <Toaster containerClassName="text-[12px]" /> */}
    </React.Fragment>
  );
};

LayoutMain.propTypes = {
  children: PropTypes.object,
  location: PropTypes.object,
};
export default withRouter(LayoutMain);
